var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaloonsDecor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 474,
    viewBox: "0 0 474 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.463 123.813C341.463 181.445 294.693 273.822 237 273.822C179.307 273.822 132.536 181.445 132.536 123.813C132.536 66.1811 179.307 12 237 12C294.693 12 341.463 66.1811 341.463 123.813Z",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 273.822V462",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.294 259.21C178.133 292.46 148.916 320.483 116.463 320.483C58.7701 320.482 12 228.106 12 170.474C12 112.841 58.7701 58.6609 116.463 58.6609C126.83 58.6609 140.175 61.5177 149.629 64.327",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.463 461.917V320.482L88.3525 348.564",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.506 64.5483C333.93 61.7586 347.206 58.6619 357.537 58.6619C415.23 58.6609 462 112.842 462 170.474C462 228.106 415.23 320.483 357.537 320.483C325.084 320.483 295.865 292.482 276.705 259.232",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.537 320.482V461.917",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.464 320.482L143.815 347.805",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.997 273.821L264.348 301.144",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.999 273.821L209.647 301.143",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.534 320.482L384.886 347.805",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.536 320.482L330.185 347.805",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloonsDecor);
export default __webpack_public_path__ + "static/media/baloonsDecor.d9110d0c8d9164800e1d904a4bdf5d45.svg";
export { ForwardRef as ReactComponent };